<template>
  <div>
    <Title title="Administración SOC"
           subtitle="Adelanta, habilita o deshabilita SOC"/>
    <el-row>
      <el-form :inline="true">
        <el-form-item>
          <el-input v-model="filter.code"
                    placeholder="Suborden"
                    clearable/>
        </el-form-item>
        <el-form-item>
          <el-select  v-model="filter.distribution_centers_id"
                      placeholder="CT"
                      filterable
                      multiple
                      style="width: 300px;"
                      autocomplete
                      no-match-text="No existen coincidencias"
                      no-data-text="Cargando..."
                      clearable>
            <el-option  v-for="ct in data.cts"
                        :key="ct.id"
                        :label="ct.name"
                        :value="ct.id"/>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker @change="setTimeFormat()"
                          v-model="data.date"
                          placeholder="Fecha"
                          format="dd-MM-yyyy"
                          value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button class="default btnSearch"
                     icon="fa fa-search"
                     @click="handleSearch"/>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-col>
        <el-tabs type="card"
                 v-loading="filtersLoading">
          <el-tab-pane label="UNITARIA">
<!--TABLA-->
            <el-table :data="subordersChange"
                      size="mini"
                      height="400">
              <el-table-column label="SOC"
                               align="left"
                               prop="code"/>
              <el-table-column label="DO"
                               align="left"
                               prop="do"/>
              <el-table-column label="FECHA PACTADA"
                               align="left"
                               prop="requested_at"
                               class="el-icon-date">
                <span slot-scope="scope">{{ formatDate(scope.row.requested_at) }}</span>
              </el-table-column>
  <!--HABILITAR SOC-->
              <el-table-column  align="center"
                                prop="enable">
                <span slot="header"> HABILITAR</span>
                  <el-popover
                    slot="header"
                    placement="top-start"
                    title="Habilitar"
                    width="200"
                    trigger="click"
                    content="Presiona el switch para habilitar o deshabilitar una SOC">
                    <el-button slot="reference"
                               style="margin-left: 10px"
                               type="text">
                      <i class="el-icon-info"/>
                    </el-button>
                  </el-popover>
                  <el-switch slot-scope="scope"
                             v-model="scope.row.enable"
                             active-color="#AAD500"
                             @change="changeEnable(scope.row)">
                  </el-switch>
              </el-table-column>
    <!--ADELANTAR SOC-->
              <el-table-column  align="center"
                                prop="overtake">
                <span slot="header"> ADELANTAR</span>
                <el-popover
                  slot="header"
                  placement="top-start"
                  title="Adelantar"
                  width="200"
                  trigger="click"
                  content="Presiona el botón para adelantar una SOC">
                  <el-button slot="reference"
                             style="margin-left: 10px"
                             type="text">
                    <i class="el-icon-info"></i>
                  </el-button>
                </el-popover>
                <template slot-scope="scope">
                  <div v-if="dateVerify(scope.row)">
                    <div v-if="!scope.row.overtake && !scope.row.enable">
       <!--SE PUEDE ADELANTAR POR FECHA-->
                      <el-popover
                        slot="scope"
                        placement="top-start"
                        title="Advertencia"
                        width="210"
                        trigger="hover"
                        content="La SOC debe estar habilitada para adelantarla">
                        <el-button slot="reference"
                                   style="color:#9B9B9B; font-size: 18px;"
                                   type="text">
                          <i class="el-icon-warning-outline"></i>
                        </el-button>
                      </el-popover>
                    </div>
      <!--DISPONIBLE PARA ADELANTAR -->
                    <div v-if="!scope.row.overtake && scope.row.enable">
                      <el-button type="text"
                                 size="mini"
                                 @click="changeOvertake(scope.row)">
                        <i class="far fa-share-square" style="color:#a5a5a5; font-size: 18px;"></i>
                      </el-button>
                    </div>
      <!-- ADELANTADA OK -->
                    <div v-if="scope.row.overtake">
                      <p>Adelantado</p>
                      <el-button type="text"
                                 size="mini">
                        <i class="el-icon-success"
                           style="color:#AAD500; font-size: 18px;"></i>
                      </el-button>
                    </div>
                  </div>
      <!-- NO SE PUEDE HABILITAR POR FECHA ANTERIOR A LA ACTUAL-->
                  <div v-else>
                    <el-popover
                      slot="scope"
                      placement="top-start"
                      title="Advertencia"
                      width="210"
                      trigger="hover"
                      content="Fecha pactada anterior a la actual, no es posible Adelantar SOC">
                      <el-button slot="reference"
                                 style="color:#F5A623; font-size: 18px;"
                                 type="text">
                        <i class="el-icon-warning-outline"></i>
                      </el-button>
                    </el-popover>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <el-col :span="20" :offset="4" class="toolbar">
              <el-pagination layout="total, prev, pager, next"
                             @current-change="handleCurrentChange"
                             :page-size="100"
                             :pager-count="5"
                             :total="totalSize"
                             style="float:right;">
              </el-pagination>
            </el-col>
          </el-tab-pane>
<!--MASIVO-->
          <el-tab-pane label="MASIVA">
            <el-tabs>
              <el-tab-pane label="CENTROIDES">
                <el-input   type="textarea"
                            :rows="14"
                            placeholder="Ej: 124005957704, 124005957705, 124005957706 ..."
                            v-model="textareaToCentroide">
                </el-input>
                <p></p>
                <el-button  class="default"
                            @click="ToCentroides()">
                  CENTROIDES
                </el-button>
              </el-tab-pane>
              <el-tab-pane label="DESHABILITAR">
                <el-input   type="textarea"
                            :rows="14"
                            placeholder="Ej: 124005957704, 124005957705, 124005957706 ..."
                            v-model="textareaToDisable">
                </el-input>
                <p></p>
                <el-button  class="default"
                            @click="checkOrdersDisable()">
                  DESHABILITAR
                </el-button>
              </el-tab-pane>
              <el-tab-pane label="HABILITAR">
                <el-input   type="textarea"
                            :rows="14"
                            placeholder="Ej: 124005957704, 124005957705, 124005957706 ..."
                            v-model="textareaToEnable">
                </el-input>
                <p></p>
                <el-button  class="default"
                            @click="checkOrdersEnable()">
                  HABILITAR
                </el-button>
              </el-tab-pane>
              <el-tab-pane  label="ADELANTAR">
                <el-input   type="textarea"
                            :rows="14"
                            placeholder="Ej: 124005957704, 124005957705, 124005957706 ..."
                            v-model="textareaToAdvance">
                </el-input>
                <p></p>
                <el-button  class="default"
                            @click="checkOrdersAdvance()">
                  ADELANTAR
                </el-button>
              </el-tab-pane>
            </el-tabs>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
    <el-dialog custom-class="fb-dialog"
               :show-close="false"
               :visible.sync="dialog.checkOrderCentroide">
      <span slot="title"><i class="fa fa-exclamation-circle"/>Confirmación</span>
      <div v-if="ordersToCentroide.length > 0">
        <p class="dialogText">
          Confirma si el listado de SOC a convertir en CENTROIDE es correcto:</p>
        <ol class="ordersListStyle">
          <li v-for="(orderAddAdvance, index) in ordersToCentroide" :key="index">
            {{orderAddAdvance}}
          </li>
        </ol>
      </div>
      <p class="dialogText">
        <span class="focus">¿Quieres modificar?</span>
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button  class="flat"
                    @click="dialog.checkOrderCentroide = false">
                    CANCELAR
        </el-button>
        <el-button  class="default"
                    @click="updateOrder('Centroide')">
          ACEPTAR
        </el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialog.checkOrderAdvance">
      <h3 class="dialogTitle">
        <i class="fa fa-exclamation-circle" aria-hidden="true"></i>ADVERTENCIA
      </h3>
      <div v-if="ordersToAdvance.length > 0">
        <p class="dialogText">Confirma si el listado de SOC a ADELANTAR es correcto:</p>
        <ol class="ordersListStyle">
          <li v-for="(orderAddAdvance, index) in ordersToAdvance"
              :key="index">{{orderAddAdvance}}</li>
        </ol>
      </div>
      <p class="dialogText">
        <span class="focus">¿Quieres modificar?</span>
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button  class="flat"
                    @click="dialog.checkOrderAdvance = false">
                    CANCELAR
        </el-button>
        <el-button  class="default"
                    @click="updateOrder('Advance')">
                    ACEPTAR
        </el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialog.checkOrderDisable">
      <h3 class="dialogTitle">
        <i class="fa fa-exclamation-circle" aria-hidden="true"></i>ADVERTENCIA
      </h3>
      <div v-if="ordersToDisable.length > 0">
        <p class="dialogText">Confirma si el listado de SOC a DESHABILITAR es correcto:</p>
        <ol class="ordersListStyle">
          <li v-for="(orderAddDisable, index) in ordersToDisable"
              :key="index">{{orderAddDisable}}</li>
        </ol>
      </div>
      <p class="dialogText">
        <span class="focus">¿Quieres modificar?</span>
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button  class="flat"
                    @click="dialog.checkOrderDisable = false">
                    CANCELAR
        </el-button>
        <el-button  class="default"
                    @click="updateOrder('Disable')">
                    ACEPTAR
        </el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialog.checkOrderEnable">
      <h3 class="dialogTitle">
        <i class="fa fa-exclamation-circle" aria-hidden="true"></i>ADVERTENCIA
      </h3>
      <div v-if="ordersToEnable.length > 0">
        <p class="dialogText">Confirma si el listado de SOC a HABILITAR es correcto:</p>
        <ol class="ordersListStyle">
          <li v-for="(orderAddEnable, index) in ordersToEnable"
              :key="index">{{orderAddEnable}}</li>
        </ol>
      </div>
      <p class="dialogText">
        <span class="focus">¿Quieres modificar?</span>
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button  class="flat"
                    @click="dialog.checkOrderEnable = false">
                    CANCELAR
        </el-button>
        <el-button  class="default"
                    @click="updateOrder('Enable')">
                    ACEPTAR
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment';
import { apiRequest } from '../../backend/vue-axios/axios';
import Title from '../components/base/Title.vue';

export default {
  name: 'ViewPlanningAdmin',
  components: {
    Title,
  },
  data() {
    return {
      data: {
        cts: [],
      },
      filter: {
        requested_at: '',
        code: null,
        distribution_centers_id: [],
        limit: 100,
      },
      date: '',
      subordersChange: [],
      filtersLoading: false,
      loading: false,
      totalSize: 0,
      // Masiva
      ordersToCentroide: [],
      ordersToDisable: [],
      ordersToEnable: [],
      ordersToAdvance: [],
      textareaToCentroide: '',
      textareaToDisable: '',
      textareaToEnable: '',
      textareaToAdvance: '',
      dialog: {
        checkOrderCentroide: false,
        checkOrderDisable: false,
        checkOrderEnable: false,
        checkOrderAdvance: false,
      },
      ordersToModify: {
        orders_disable: [],
      },
      enableCode: null,
      disableCode: null,
      overtakeCode: null,
    };
  },
  methods: {
    getStatus(parameters = {}) {
      if (!(this.validateNumber(parameters.code))) {
        this.$notify({
          type: 'error',
          title: 'Error',
          message: 'El campo SOC debe ser númerico',
        });
      } else {
        this.filtersLoading = true;
        apiRequest(
          {
            module: 'planning',
            service: 'suborders_planning',
            params: parameters,
          },
        ).then((res) => {
          this.code = res.data;
          this.totalSize = parseInt(res.headers['x-total-count'], 10);
          this.subordersChange = [];
          this.code.forEach((element) => {
            if (element.first_do !== 0) {
              // eslint-disable-next-line no-param-reassign
              element.do = element.first_do;
            }
            this.subordersChange.push(element);
          });
          this.filtersLoading = false;
        }).catch(() => {
          this.$notify({
            type: 'error',
            title: 'Error',
            message: 'Problemas al cargar las subrdenes',
          });
          this.filtersLoading = false;
        });
      }
    },
    getDistributionCenters() {
      apiRequest({
        module: 'planning',
        service: 'distribution_centers',
        params: { limit: 1000 },
      }).then((data) => {
        this.data.cts = data.data;
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Problemas al cargar CT',
        });
      });
    },
    getLimitPage(page) {
      return ((page - 1) * 100);
    },
    handleCurrentChange(newPage) {
      this.getStatus({
        offset: this.getLimitPage(newPage),
        requested_at: this.filter.requested_at,
        code: this.filter.code,
        distribution_centers_id: this.filter.distribution_centers_id,
        limit: this.filter.limit,
      });
    },
    formatDate(date) {
      return moment.utc(date).format('DD-MM-YYYY');
    },
    compareDate(date) {
      return moment().isSame(date);
    },
    handleSearch() {
      if (this.filter.requested_at === 'nullT00:00:00Z') {
        this.filter.requested_at = '';
      }
      if (this.filter.requested_at === ''
        && this.filter.code === null
        && this.filter.distribution_centers_id === []) {
        this.getStatus();
      } else {
        this.getStatus(this.filter);
      }
    },
    formatter(row) {
      return `${row.description.substr(0, 15)} ...`;
    },
    validateNumber(number) {
      if (number === undefined || number === null) {
        return true;
      }
      return /^([0-9]*)/.test(number);
    },
    setTimeFormat() {
      this.filter.requested_at = `${this.data.date}T00:00:00Z`; // TODO añado horario fijo (search)
    },
    dateVerify(row) {
      return moment.utc().subtract(1, 'days').isSameOrBefore(row.requested_at);
    },
    changeEnable(row) {
      let enableMessage = '';
      if (row.enable) {
        enableMessage = 'habilitar';
      } else {
        enableMessage = 'deshabilitar';
      }
      this.$confirm(`¿Quieres ${enableMessage} la SOC?`, 'Advertencia', {
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(() => {
        this.changeOption(row, 'enable');
        this.$message({
          message: 'Modificando SOC',
        });
      }).catch(() => {
        const subordersSelected = this.subordersChange.filter(suborder => suborder.id === row.id);
        subordersSelected[0].enable = false;
      });
    },
    changeOvertake(row) {
      let enableMessage = '';
      if (!row.overtake) {
        enableMessage = 'adelantar';
      }
      this.$confirm(`¿Quieres ${enableMessage} la SOC?`, 'Advertencia', {
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(() => {
        const subOvertakeSelected = this.subordersChange.filter(suborder => suborder.id === row.id);
        this.$message({
          message: 'Adelantando SOC',
        });
        subOvertakeSelected[0].overtake = true;
        this.changeOption(row, 'overtake');
      }).catch(() => null);
    },
    changeOption(row, type) {
      const orderSend = {
        enable: [],
        disable: [],
        overtake: [],
      };
      if (type === 'enable') {
        if (row.enable) {
          this.enableCode = row.code;
          orderSend.enable.push(row.code);
        } else {
          orderSend.disable.push(row.code);
          this.disableCode = row.code;
        }
      }
      if (type === 'overtake') {
        orderSend.overtake.push(row.code);
        this.overtakeCode = row.code;
      }
      this.changeOptionRest(orderSend);
    },
    ChangeToCentroideRest() {
      apiRequest(
        {
          module: 'planning',
          service: 'socs_to_centroide',
          params: {
            codes: this.ordersToCentroide,
          },
        },
      ).then(() => {
        this.$notify({
          type: 'success',
          title: 'OK',
          message: 'Subordenes modificadas',
        });
      }).catch(() => {
        this.$notify({
          type: 'error',
          title: 'Error',
          message: 'Las SOC no pudieron ser modificadas',
        });
      });
      this.hideDialog();
      this.cleanTextArea();
    },
    changeOptionRest(orderSend) {
      apiRequest(
        {
          module: 'planning',
          service: 'adm_suborden',
          params: orderSend,
        },
      ).then((res) => {
        const issusesResponse = [
          'issues_response_enabled',
          'issues_response_disabled',
          'issues_response_overtake',
        ];
        const errorMessage = [
          {
            key: 'cant_overtake_disabled',
            traslate: 'No puede adelantar una SOC deshabilitada',
          },
          {
            key: 'suborder_belated',
            traslate: 'No se puede adelantar SOC con fecha pactada anterior a la actual',
          },
          {
            key: 'suborder_in_route',
            traslate: 'No se puede modificar una SOC en Ruta',
          },
          {
            key: 'suborder_not_found',
            traslate: 'SOC no encontrada',
          },
          {
            key: 'canceled_or_terminated',
            traslate: 'SOC fue cancelada o entregada',
          },
        ];
        let msg = '';
        if (Object.keys(res.data).length > 0) {
          issusesResponse.forEach((issusesItem) => {
            const issuseIndex = Object.keys(res.data).indexOf(issusesItem);
            if (issuseIndex > -1) {
              const responseError = res.data[issusesItem];
              if (JSON.stringify(responseError) !== '{}') {
                errorMessage.forEach((errorItem) => {
                  if (Object.keys(responseError).indexOf(errorItem.key) > -1) {
                    const errorMessaje = responseError[errorItem.key];
                    msg += `${errorItem.traslate}:\n`;
                    msg += errorMessaje.join(',\n');
                    msg += '\n';
                  }
                });
              }
            }
          });
          if (msg !== '') {
            this.$notify({
              type: 'error',
              title: 'Error',
              duration: 8500,
              message: msg,
            });
          } else {
            this.$notify({
              type: 'success',
              title: 'OK',
              message: 'Suborden Modificada',
            });
            // this.disable = true; // TODO disableeeeeeeee
          }
        }
        if (orderSend.enable.length > 0) {
          this.getStatus({ code: this.enableCode });
        }
        if (orderSend.disable.length > 0) {
          this.getStatus({ code: this.disableCode });
        }
        if (orderSend.overtake.length > 0) {
          this.getStatus({ code: this.overtakeCode });
        }
      }).catch(() => { // TODO revisar mensaje
        this.$notify({
          type: 'error',
          title: 'Error',
          message: 'La SOC no pudo ser modificada',
        });
      });
      this.hideDialog();
      this.cleanTextArea();
    },
    // Masivo
    ToCentroides() {
      const ordersError = [];
      this.cleanCheckOrder();
      if (this.textareaToCentroide.trim() === '') {
        this.$notify.error({
          title: 'Error',
          message: 'Debes agregar al menos una SOC',
        });
      } else {
        let orders;
        const ordersToNumbersDisable = [];
        if (this.textareaToCentroide.indexOf(', ') !== -1) {
          orders = this.textareaToCentroide.split(', ');
        } else if (this.textareaToCentroide.indexOf('\n' !== -1)) {
          orders = this.textareaToCentroide.split('\n');
        } else if (this.textareaToCentroide.indexOf('\r' !== -1)) {
          orders = this.textareaToCentroide.split('\r');
        }
        orders.filter(e => e !== '').forEach((orderStringNumber) => {
          if (this.validateNumber(orderStringNumber.trim())) {
            ordersToNumbersDisable.push(parseInt(orderStringNumber, 10));
          } else {
            ordersError.push(orderStringNumber);
          }
        });
        this.ordersToCentroide = ordersToNumbersDisable;
        if (ordersError.length > 0) {
          this.$notify({
            type: 'error',
            title: 'Error',
            message: `El formato de las siguientes ordenes no corresponden:${ordersError.join(', ')}`,
          });
        } else {
          this.dialog.checkOrderCentroide = true;
        }
      }
    },
    checkOrdersDisable() {
      const ordersError = [];
      this.cleanCheckOrder();
      if (this.textareaToDisable.trim() === '') {
        this.$notify.error({
          title: 'Error',
          message: 'Debes agregar al menos una SOC',
        });
      } else {
        if (this.textareaToDisable.trim() !== '') {
          let orders;
          const ordersToNumbersDisable = [];
          if (this.textareaToDisable.indexOf(', ') !== -1) {
            orders = this.textareaToDisable.split(', ');
          } else if (this.textareaToDisable.indexOf('\n' !== -1)) {
            orders = this.textareaToDisable.split('\n');
          } else if (this.textareaToDisable.indexOf('\r' !== -1)) {
            orders = this.textareaToDisable.split('\r');
          }
          orders.filter(e => e !== '').forEach((orderStringNumber) => {
            if (this.validateNumber(orderStringNumber.trim())) {
              ordersToNumbersDisable.push(parseInt(orderStringNumber, 10));
            } else {
              ordersError.push(orderStringNumber);
            }
          });
          this.ordersToDisable = ordersToNumbersDisable;
        }
        if (ordersError.length > 0) {
          this.$notify({
            type: 'error',
            title: 'Error',
            message: `El formato de las siguientes ordenes no corresponden:${ordersError.join(', ')}`,
          });
        } else {
          this.dialog.checkOrderDisable = true;
        }
      }
    },
    checkOrdersEnable() {
      const ordersError = [];
      this.cleanCheckOrder();
      if (this.textareaToEnable.trim() === '') {
        this.$notify.error({
          title: 'Error',
          message: 'Debes agregar al menos una SOC',
        });
      } else {
        if (this.textareaToEnable.trim() !== '') {
          let orders;
          const ordersToNumbersEnable = [];
          if (this.textareaToEnable.indexOf(', ') !== -1) {
            orders = this.textareaToEnable.split(', ');
          } else if (this.textareaToEnable.indexOf('\n' !== -1)) {
            orders = this.textareaToEnable.split('\n');
          } else if (this.textareaToEnable.indexOf('\r' !== -1)) {
            orders = this.textareaToEnable.split('\r');
          }
          orders.filter(e => e !== '').forEach((orderStringNumber) => {
            if (this.validateNumber(orderStringNumber.trim())) {
              ordersToNumbersEnable.push(parseInt(orderStringNumber, 10));
            } else {
              ordersError.push(orderStringNumber);
            }
          });
          this.ordersToEnable = ordersToNumbersEnable;
        }
        if (ordersError.length > 0) {
          this.$notify({
            type: 'error',
            title: 'Error',
            message: `El formato de las siguientes ordenes no corresponden:${ordersError.join(', ')}`,
          });
        } else {
          this.dialog.checkOrderEnable = true;
        }
      }
    },
    checkOrdersAdvance() {
      const ordersError = [];
      this.cleanCheckOrder();
      if (this.textareaToAdvance.trim() === '') {
        this.$notify.error({
          title: 'Error',
          message: 'Debes agregar al menos una SOC',
        });
      } else {
        if (this.textareaToAdvance.trim() !== '') {
          let orders;
          const ordersToNumbersAdvance = [];
          if (this.textareaToAdvance.indexOf(', ') !== -1) {
            orders = this.textareaToAdvance.split(', ');
          } else if (this.textareaToAdvance.indexOf('\n' !== -1)) {
            orders = this.textareaToAdvance.split('\n');
          } else if (this.textareaToAdvance.indexOf('\r' !== -1)) {
            orders = this.textareaToAdvance.split('\r');
          }
          orders.filter(e => e !== '').forEach((orderStringNumber) => {
            if (this.validateNumber(orderStringNumber.trim())) {
              ordersToNumbersAdvance.push(parseInt(orderStringNumber, 10));
            } else {
              ordersError.push(orderStringNumber);
            }
          });
          this.ordersToAdvance = ordersToNumbersAdvance;
        }
        if (ordersError.length > 0) {
          this.$notify({
            type: 'error',
            title: 'Error',
            message: `El formato de las siguientes ordenes no corresponden:${ordersError.join(', ')}`,
          });
        } else {
          this.dialog.checkOrderAdvance = true;
        }
      }
    },
    cleanCheckOrder() {
      this.ordersToCentroide = [];
      this.ordersToDisable = [];
      this.ordersToEnable = [];
      this.ordersToAdvance = [];
    },
    cleanTextArea() {
      this.textareaToCentroide = '';
      this.textareaToAdvance = '';
      this.textareaToEnable = '';
      this.textareaToDisable = '';
    },
    hideDialog() {
      this.dialog.checkOrderCentroide = false;
      this.dialog.checkOrderDisable = false;
      this.dialog.checkOrderEnable = false;
      this.dialog.checkOrderAdvance = false;
    },
    updateOrder(action) {
      if (action === 'Centroide') {
        this.ChangeToCentroideRest();
      } else {
        const orderSend = {
          enable: [],
          disable: [],
          overtake: [],
        };
        if (action === 'Disable') {
          orderSend.disable = this.ordersToDisable;
        }
        if (action === 'Enable') {
          orderSend.enable = this.ordersToEnable;
        }
        if (action === 'Advance') {
          orderSend.overtake = this.ordersToAdvance;
        }
        this.changeOptionRest(orderSend);
      }
    },
  },
  beforeMount() {
    this.getStatus({ limit: 100 });
    this.getDistributionCenters();
  },
};

</script>
<style lang="scss" scoped>
  .btnSearch {
    height: 40px;
  }
  .content {
    margin: 0 0 0 30px;
  }
  .dialogTitle {
    padding: 0 40px;
    font-size: 1.2em;
    text-transform: uppercase;
    font-weight: 700;
    margin-top: 0;
    text-align: left;
    .fa-exclamation-circle {
      color: #F5A623;
      font-size: 1.4em;
      margin-right: 0.5em;
    }
  }
  .dialogText {
    width: 85%;
    text-align: left;
    margin: auto;
    .focus {
      display: block;
    }
  }
  .ordersListStyle {
    max-height: 200px;
    overflow-x: auto;
    text-align: left;
    list-style: none;
    li {
      counter-increment: li;
      &::before {
        content: counter(li)' )';
        font-weight: 900;
        color: #AAD500;
        display: inline-block;
        margin-right: 0.5em;
        padding-left: 30px;
      }
    }
  }
  .focus {
    text-transform: uppercase;
    font-weight: 900;
    color: #AAD500;
    &.small {
      display: block;
      font-style: italic;
      margin-top: 0.5em;
      font-size: 0.85em;
    }
  }
  .input {
    margin: 8px 0 16px 0;
  }
  .tableStyle {
    box-sizing: border-box;
    overflow: hidden;
    margin-top: 0;
  }
  .grey {
    background-color: #606266;
    align-self: flex-end;
    height: 40px;
  }
  .titleStyle {
    font-size: 12px;
    color: #AAD500;
    font-weight: 900;
    text-transform: uppercase;
    margin: 0 0 10px 10px;
  }
  .titleStyleNumRoutes {
    font-size: 12px;
    color: #AAD500;
    font-weight: 600;
    text-transform: uppercase;
    margin: 0 0 10px 0px;
  }
  .linkStyle {
    color: #AAD500;
    border: none;
    font-weight: 600;
    font-size: 15px;
    outline: none;
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.0);
    margin: 0;
    padding: 0;
  }
  .smallTextPopover {
    font-size: 11px;
    font-weight: 300;
    width: 80%;
  }
  .popoverStyle {
    text-align: right;
    margin: 0
  }
  .buttonsSection {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
  }
  .setPadding {
    width: 99%;
  }
  .el-tabs__header {
    margin: 0;
  }
  @media only screen and (max-width: 767px) {
    .setPadding {
      padding: 0 30px;
      box-sizing: border-box;
    }
  }
</style>
